import { useEffect, useState } from "react";
import { dashboardTechniciens } from "../../api/rendezVousService.api";
import TechnicienCard from "./TechnicienCard";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "./Dashboard.css";

const DashboardTechnicien = () => {
  const [statsParTechnicien, setStatsParTechnicien] = useState([]);
  const [loading, setLoading] = useState(true);

  // mois sélectionné (par défaut : mois courant)
  const [mois, setMois] = useState(
    new Date().toISOString().slice(0, 7)
  );

  useEffect(() => {
    loadData();
  }, [mois]);

  const loadData = async () => {
    try {
      setLoading(true);

      const res = await dashboardTechniciens(mois);

      setStatsParTechnicien(res.data);
    } catch (err) {
      console.error("Erreur dashboard technicien :", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p>Chargement...</p>;
  }

  return (
    <div className="dashboard-container">
      <h2>👨‍🔧 Dashboard Techniciens</h2>

      {/* Filtre mois */}
      <div
        style={{
          marginBottom: "20px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <label>
          <strong>Mois :</strong>
        </label>

        <input
          type="month"
          value={mois}
          onChange={(e) => setMois(e.target.value)}
        />
      </div>

      <div className="dashboard-top">
        {/* Cartes */}
        <div className="dashboard-grid">
          {statsParTechnicien.map((t) => (
            <TechnicienCard
              key={t.technicien_id}
              data={t}
            />
          ))}
        </div>

        {/* Graphique */}
        <div className="dashboard-graph">
          <h3>⏱️ Heures travaillées par technicien</h3>

          <ResponsiveContainer width="100%" height={350}>
            <BarChart
              data={statsParTechnicien}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <XAxis dataKey="technicien_nom" />

              <YAxis />

              <Tooltip
                formatter={(value) =>
                  `${Number(value).toFixed(2)} h`
                }
              />

              <Legend />

              <Bar
                dataKey="total_heures"
                fill="#4CAF50"
                name="Heures"
              />

              <Bar
                dataKey="termine"
                fill="#2196F3"
                name="RDV terminés"
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default DashboardTechnicien;